import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { AuthService } from "../../../services/auth.service";
let LimitExceededModalWalletComponent = class LimitExceededModalWalletComponent {
    constructor(sanitizer, router, location, themeService, auth) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.auth = auth;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() { }
    close() {
        this.modal.destroy();
    }
    goToVerification() {
        this.close();
        this.router.navigateByUrl('/verify');
    }
};
LimitExceededModalWalletComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: AuthService }
];
LimitExceededModalWalletComponent = __decorate([
    Component({
        selector: 'app-limit-exceeded-modal-wallet',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./limit-exceeded-modal-wallet.component.html")).default,
    })
], LimitExceededModalWalletComponent);
export { LimitExceededModalWalletComponent };
